import { render, staticRenderFns } from "./LinkWizardPreReleaseServices.vue?vue&type=template&id=e227e0b8&scoped=true&"
import script from "./LinkWizardPreReleaseServices.vue?vue&type=script&lang=js&"
export * from "./LinkWizardPreReleaseServices.vue?vue&type=script&lang=js&"
import style0 from "./LinkWizardPreReleaseServices.vue?vue&type=style&index=0&id=e227e0b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e227e0b8",
  null
  
)

export default component.exports